export const WholesaleInquiryStatus = Object.freeze({
    new: Symbol('new'),
    expired: Symbol('expired'),
    assigned: Symbol('assigned'),
});

export function getStatusText(status) {
    return {
        [WholesaleInquiryStatus.new]: 'Nowe',
        [WholesaleInquiryStatus.expired]: 'Wygasłe',
        [WholesaleInquiryStatus.assigned]: 'Wybrany wykonawca',
    }[WholesaleInquiryStatus[status]];
}
